<template>
  <div class="w-100" style="min-height:38px;text-align:left;">
    <b-form>
      <PortionsTable
        ref="portionsTable"
        v-model="formData.portions"
        :requirements="formData.requirements"
        :cho-grams="formData.cho_grams"
        :lipid-grams="formData.lipid_grams"
        :protein-grams="formData.protein_grams"
        @update-totals="updateTotals"
      />
    </b-form>
  </div>
</template>

<script>
import PortionsTable from '../table/PortionsTable'

export default {
  name: "PortionsSettings",
  components: {
    PortionsTable
  },
  model: {
    prop: "dietData",
    event: "change",
  },
  props: {
    dietData: {
      type: Object,
      default: function () {
        return {
          requirements: 0,
          portions: [],
          cho_grams: 0,
          lipid_grams: 0,
          protein_grams: 0,
          total_requirements: 0,
          total_cho_grams: 0,
          total_lipid_grams: 0,
          total_protein_grams: 0
        }
      },
    }
  },
  data: function() {
    return {
      showDetail: true,
      formData: this.dietData,
    };
  },
  methods: {
    validate: function() {
      var isValid = this.$refs.portionsTable.validate()
      this.$emit('on-validate', isValid)
      return isValid
    },
    updateTotals: function(totals) {
      this.formData.total_requirements = totals.calories
      this.formData.total_cho_grams = totals.cho
      this.formData.total_lipid_grams = totals.lipid
      this.formData.total_protein_grams = totals.protein
    }
  },
  watch: {
    formData: function(val) {
      this.$emit("change", val)
    },
  }
};
</script>

<style>

</style>